var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgViber = function SvgViber(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.32812,
    y: 0.510254,
    width: 35.53,
    height: 35.53,
    rx: 11.5,
    fill: "url(#paint0_linear_3577_822)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3577_822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 37
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.32812,
    y: 0.510254,
    width: 35.53,
    height: 35.53,
    rx: 11.5,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3577_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4269 -2.93237H2.96919C-0.0184593 -2.93237 -2.44043 -0.510403 -2.44043 2.47725V34.935C-2.44043 37.9226 -0.0184593 40.3446 2.96919 40.3446H35.4269C38.4146 40.3446 40.8366 37.9226 40.8366 34.935V2.47725C40.8366 -0.510403 38.4146 -2.93237 35.4269 -2.93237Z",
    fill: "#7B519D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8051 22.8075C26.2459 22.3573 25.6482 21.9532 25.06 21.5404C23.8868 20.7164 22.8137 20.6523 21.9382 21.978C21.4466 22.7223 20.7584 22.7549 20.0388 22.4284C18.055 21.5289 16.5232 20.1429 15.6259 18.1266C15.2289 17.2345 15.2341 16.4347 16.1629 15.8038C16.6546 15.4701 17.1499 15.0753 17.1103 14.3462C17.0586 13.3955 14.7504 10.2185 13.8388 9.88313C13.4617 9.74436 13.086 9.75339 12.7023 9.88235C10.5649 10.6011 9.67964 12.3589 10.5275 14.4403C13.0568 20.6498 17.5081 24.9727 23.6355 27.6112C23.9848 27.7614 24.3729 27.8215 24.5694 27.8754C25.9644 27.8894 27.5986 26.5454 28.0706 25.2115C28.525 23.9283 27.5647 23.4189 26.8051 22.8075ZM19.9347 10.5198C24.4143 11.2086 26.4802 13.3386 27.0506 17.8504C27.1035 18.2671 26.9483 18.8942 27.5429 18.9058C28.1643 18.9177 28.0145 18.2998 28.0197 17.8827C28.0723 13.6334 24.3672 9.6942 20.0643 9.54896C19.7396 9.59568 19.0679 9.32509 19.026 10.0527C18.9981 10.5433 19.5636 10.4627 19.9347 10.5198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8112 11.7568C20.3803 11.7049 19.8115 11.5019 19.7108 12.0998C19.6057 12.7273 20.2396 12.6635 20.647 12.7547C23.4137 13.3731 24.377 14.38 24.8325 17.1244C24.899 17.5245 24.7669 18.1472 25.4468 18.044C25.9507 17.9673 25.7687 17.4335 25.8108 17.1217C25.8332 14.4869 23.5754 12.0888 20.8112 11.7568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0649 13.9114C20.7773 13.9185 20.495 13.9496 20.3893 14.2569C20.2306 14.7163 20.5646 14.8259 20.9045 14.8805C22.0394 15.0627 22.6367 15.7319 22.7501 16.8636C22.7807 17.1708 22.9757 17.4197 23.2724 17.3847C23.6836 17.3356 23.7208 16.9696 23.7082 16.6221C23.7285 15.3506 22.2913 13.8809 21.0649 13.9114Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgViber);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;